(() => {
  const currentProductHandle = () => {
    const match = location.pathname.toLowerCase().match(/\/products\/([^/?#]+)/);
    return match?.[1] || '';
  };

  const trackerHandle = 'smart-pet-tracker-collar-dual-system-tracking-no-monthly-fee';
  const isTrackerProduct = () => currentProductHandle() === trackerHandle;

  const squareCareHandles = new Set([
    'portable-dog-water-bottle-with-food-storage-2-in-1-travel-bottle-for-dogs-cats',
    'elevated-anti-splash-floating-cat-water-bowl',
    '3-in-1-pet-mist-grooming-brush-deshed-detangle-refresh',
    'slow-feeder-bowl-for-cats-dogs-slower-calmer-mealtimes',
    'calm-feeding-set',
    'care-go-set'
  ]);

  const fullImageSquareCareHandles = new Set([
    'calm-feeding-set',
    'care-go-set'
  ]);

  const shouldUseSquareCare = () => squareCareHandles.has(currentProductHandle());
  const shouldContainSquareCareImage = () => fullImageSquareCareHandles.has(currentProductHandle());

  const applySquareCareFrame = (panel) => {
    if (!panel || !shouldUseSquareCare()) return;
    panel.classList.add('pll-care-square');

    panel.querySelectorAll('.pl-story__visual, .pll-visual, .pl-story__track, .pll-track').forEach((el) => {
      el.style.setProperty('min-height', '0', 'important');
      el.style.setProperty('height', 'auto', 'important');
    });

    panel.querySelectorAll('.pl-story__slide, .pll-slide').forEach((slide) => {
      slide.style.setProperty('aspect-ratio', '1 / 1', 'important');
      slide.style.setProperty('height', 'auto', 'important');
      slide.style.setProperty('min-height', '0', 'important');
    });

    panel.querySelectorAll('.pl-story__slide img, .pll-slide img').forEach((img) => {
      img.style.setProperty('display', 'block', 'important');
      img.style.setProperty('width', '100%', 'important');
      img.style.setProperty('height', '100%', 'important');
      img.style.setProperty('aspect-ratio', '1 / 1', 'important');
      img.style.setProperty('object-fit', shouldContainSquareCareImage() ? 'contain' : 'cover', 'important');
      img.style.setProperty('object-position', 'center center', 'important');
    });
  };

  const isSizeHelpProduct = () => {
    const path = location.pathname.toLowerCase();
    const isRetractableLeash = path.includes('retractable') && path.includes('leash');
    const isHarnessLeashSet = path.includes('soft-no-pull-cat-harness-leash-set') || (path.includes('harness') && path.includes('leash') && path.includes('set'));
    return isRetractableLeash || isHarnessLeashSet;
  };

  const present = (v) => v !== null && v !== undefined && String(v).trim() !== '';

  const uniqueImageUrls = (section) => {
    const urls = [];
    section.querySelectorAll('.pl-story__track .pl-story__slide img, [data-pll-slide] img').forEach((img) => {
      const url = img.currentSrc || img.src;
      if (url && !urls.includes(url)) urls.push(url);
    });
    return urls.slice(0, 3);
  };

  const makeImage = (url, alt) => {
    const img = document.createElement('img');
    img.loading = 'lazy';
    img.alt = alt || '';
    if (url) img.src = url;
    return img;
  };

  const makeSlide = (url, index, alt) => {
    const figure = document.createElement('figure');
    figure.className = `pll-slide pl-story__slide${index === 0 ? ' is-active' : index === 1 ? ' is-next' : ' is-prev'}`;
    figure.setAttribute('data-feature-slide', '');
    figure.setAttribute('data-index', String(index));
    figure.dataset.featureIndex = String(index);
    figure.appendChild(makeImage(url, alt));
    return figure;
  };

  const makeText = (value, active) => {
    const article = document.createElement('article');
    article.className = `pll-text pl-story__text${active ? ' is-active' : ''}`;
    article.setAttribute('data-feature-text', '');
    const p = document.createElement('p');
    p.textContent = value || '';
    p.style.whiteSpace = 'pre-line';
    article.appendChild(p);
    return article;
  };

  const customCare = (section) => Array.isArray(section?.__powlifeCareCarouselData) ? section.__powlifeCareCarouselData : [];

  const upgradeTrackerCarePanel = (section, force = false) => {
    if (!section || !isTrackerProduct()) return false;
    const panel = section.querySelector('[data-pll-panel="help"]');
    const template = document.querySelector('[data-tracker-care-video-template]');
    if (!panel || !template) return false;
    if (panel.dataset.trackerCareVideo === 'true' && !force) return true;

    panel.dataset.trackerCareVideo = 'true';
    delete panel.dataset.careUseCarousel;
    panel.removeAttribute('data-feature-carousel');
    panel.classList.remove('pll-help-panel', 'pll-help-panel--size-help', 'pll-care-carousel-panel', 'pl-story--published', 'pll-care-square');
    panel.classList.add('pll-feature-panel', 'pll-tracker-video-panel');
    panel.replaceChildren(template.content.cloneNode(true));
    return true;
  };

  const refreshCarePanel = (section) => {
    if (!section || isSizeHelpProduct() || isTrackerProduct()) return;
    const panel = section.querySelector('[data-pll-panel="help"]');
    if (!panel || panel.dataset.careUseCarousel !== 'true') return;
    const custom = customCare(section);

    if (custom.length) {
      panel.querySelectorAll('.pl-story__slide').forEach((slide) => {
        const index = Number(slide.dataset.featureIndex ?? slide.dataset.index ?? -1);
        const item = custom[index];
        const img = slide.querySelector('img');
        if (img && item && present(item[1])) {
          img.src = item[1];
          img.srcset = item[1];
          if (present(item[0])) img.alt = item[0];
        }
      });

      panel.querySelectorAll('[data-feature-text]').forEach((copy, index) => {
        const value = custom[index]?.[0];
        const p = copy.querySelector('p:last-child');
        if (p && present(value)) p.textContent = value;
      });
    }

    applySquareCareFrame(panel);
  };

  const upgradeCarePanel = (section) => {
    if (!section || isSizeHelpProduct()) return;
    if (isTrackerProduct()) {
      upgradeTrackerCarePanel(section);
      return;
    }

    const panel = section.querySelector('[data-pll-panel="help"]');
    if (!panel) return;
    if (panel.dataset.careUseCarousel === 'true') {
      refreshCarePanel(section);
      applySquareCareFrame(panel);
      return;
    }

    const sourceImage = panel.querySelector('img');
    const sourceImageUrl = sourceImage?.currentSrc || sourceImage?.src || '';
    const sourceCopy = panel.querySelector('.pll-help-copy > p:not(.pll-kicker)')?.textContent?.trim() || '';
    const steps = [...panel.querySelectorAll('ol li')].map((li) => li.textContent.trim()).filter(Boolean);
    const fallbackTexts = [steps[0] || sourceCopy, steps[1] || sourceCopy, steps[2] || sourceCopy];

    const featureImages = uniqueImageUrls(section);
    const fallbackImages = [
      sourceImageUrl || featureImages[0] || '',
      featureImages[1] || featureImages[0] || sourceImageUrl || '',
      featureImages[2] || featureImages[0] || sourceImageUrl || ''
    ];

    const custom = customCare(section);
    const texts = fallbackTexts.map((value, index) => present(custom[index]?.[0]) ? custom[index][0] : value);
    const images = fallbackImages.map((value, index) => present(custom[index]?.[1]) ? custom[index][1] : value);

    panel.dataset.careUseCarousel = 'true';
    panel.classList.remove('pll-help-panel', 'pll-help-panel--size-help');
    panel.classList.add('pll-feature-panel', 'pll-care-carousel-panel', 'pl-story--published');
    panel.setAttribute('data-feature-carousel', '');

    const prev = document.createElement('button');
    prev.className = 'pll-arrow pll-arrow--prev';
    prev.type = 'button';
    prev.setAttribute('data-feature-prev', '');
    prev.setAttribute('aria-label', 'Previous care tip');
    prev.textContent = '‹';

    const visual = document.createElement('div');
    visual.className = 'pll-visual pl-story__visual';
    const track = document.createElement('div');
    track.className = 'pll-track pl-story__track';
    track.setAttribute('data-feature-track', '');
    images.forEach((url, index) => track.appendChild(makeSlide(url, index, texts[index])));
    visual.appendChild(track);

    const copy = document.createElement('div');
    copy.className = 'pll-copy';
    texts.forEach((value, index) => copy.appendChild(makeText(value, index === 0)));

    const next = document.createElement('button');
    next.className = 'pll-arrow pll-arrow--next';
    next.type = 'button';
    next.setAttribute('data-feature-next', '');
    next.setAttribute('aria-label', 'Next care tip');
    next.textContent = '›';

    panel.replaceChildren(prev, visual, copy, next);
    applySquareCareFrame(panel);

    const helpTab = section.querySelector('[data-pll-tab="help"]');
    if (helpTab && helpTab.dataset.careCarouselResizeBound !== 'true') {
      helpTab.dataset.careCarouselResizeBound = 'true';
      helpTab.addEventListener('click', () => requestAnimationFrame(() => {
        applySquareCareFrame(panel);
        window.dispatchEvent(new Event('resize'));
      }));
    }

    requestAnimationFrame(() => {
      applySquareCareFrame(panel);
      panel.dispatchEvent(new Event('shopify:section:load', { bubbles: true }));
    });
  };

  const apply = (root = document) => {
    root.querySelectorAll?.('[data-powlife-lower] [data-pll-tab="features"]').forEach((el) => {
      el.textContent = 'Customer Photos';
    });
    if (isSizeHelpProduct()) return;
    root.querySelectorAll?.('[data-powlife-lower]').forEach(upgradeCarePanel);
  };

  const init = () => requestAnimationFrame(() => apply(document));

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();

  document.addEventListener('powlife:care-carousel-data', (event) => {
    const section = event.detail?.section;
    if (!section || isSizeHelpProduct()) return;
    requestAnimationFrame(() => upgradeCarePanel(section));
  });

  document.addEventListener('shopify:section:load', (event) => {
    requestAnimationFrame(() => {
      apply(event.target);
      if (isTrackerProduct() && event.target.querySelector?.('[data-tracker-care-video-template]')) {
        document.querySelectorAll('[data-powlife-lower]').forEach((section) => upgradeTrackerCarePanel(section, true));
      }
    });
  });
})();
